/* eslint-disable import/no-cycle */
import { axios, getReq, postReq, deleteReq } from '../../utils/request'
import { getAccessToken } from '../../utils/auth'
import { NOTIFICATION_TYPE } from '../../utils/enums'
import { CreateHandoverProtocolPayload, HandoverProtocolListResult, HandoverProtocolRow } from './types'

const BASE = '/api/admin/handover-protocols'

/**
 * Upload podpisu ide zamerne MIMO postReq.
 *
 * buildHeaders() v utils/request.ts vzdy nastavi 'content-type': 'application/json'. Pri FormData
 * tele to zmaze multipart boundary a multer na serveri nenajde subor. Preto sa pouziva holy
 * axios.post a Content-Type sa NEnastavuje vobec - doplni ho prehliadac aj s boundary.
 */
export const createHandoverProtocol = async (payload: CreateHandoverProtocolPayload): Promise<HandoverProtocolRow> => {
	const formData = new FormData()
	formData.append('signature', payload.signatureBlob, 'signature.png')
	formData.append('type', payload.type)
	formData.append('optionHeaderId', String(payload.optionHeaderId))
	if (payload.type === 'JOB' && payload.jobID) {
		formData.append('jobID', String(payload.jobID))
	}
	if (payload.type === 'PERSONAL' && payload.userID) {
		formData.append('userID', String(payload.userID))
	}
	if (payload.recipientUserID) {
		formData.append('recipientUserID', String(payload.recipientUserID))
	}

	const res = await axios.post(BASE, formData, {
		headers: { Authorization: `Bearer ${getAccessToken()}` }
	})
	return res.data
}

export type HandoverProtocolQuery = { type: 'JOB', jobID: number } | { type: 'PERSONAL', userID: number }

export const fetchHandoverProtocolList = async (params: HandoverProtocolQuery): Promise<HandoverProtocolListResult> => {
	const res = await getReq(BASE, params)
	return {
		protocols: res.data?.protocols || [],
		summary: res.data?.summary || { lastSignedAt: null, lastItemChangeAt: null, needsSignature: false }
	}
}

export const fetchHandoverProtocols = async (params: HandoverProtocolQuery): Promise<HandoverProtocolRow[]> => {
	const { protocols } = await fetchHandoverProtocolList(params)
	return protocols
}

export const fetchHandoverProtocolPdfUrl = async (id: number): Promise<string> => {
	const res = await getReq(`${BASE}/${id}/pdf-url`)
	return res.data?.pdfUrl
}

export const resendHandoverProtocolEmail = async (id: number) => {
	const res = await postReq(`${BASE}/${id}/resend-email`, undefined, {}, undefined, NOTIFICATION_TYPE.NOTIFICATION)
	return res.data
}

export const voidHandoverProtocol = async (id: number) => {
	const res = await deleteReq(`${BASE}/${id}`, undefined, undefined, NOTIFICATION_TYPE.NOTIFICATION)
	return res.data
}
